import isString from 'lodash/isString';
import { isNumber } from '@/utils/func';
export const addRpx = (value) => {
    if (!value) {
        return value;
    }
    return isString(value) ? value : `${value}rpx`;
};
export const getValue = (cssProp) => {
    if (!cssProp) {
        return 0;
    }
    if (isNumber(cssProp)) {
        return cssProp;
    }
    const index = cssProp.indexOf('rpx');
    if (index === -1) {
        return Number(cssProp);
    }
    return Number(cssProp.substring(0, index));
};
export const statusColor = (status) => {
    const colorMap = {
        normal: '#005BE5',
        error: '#EC3E3E',
        success: '#11D3B2',
    };
    return colorMap[status];
};
export const progressBackgroundColor = (color) => color || '#f2f4f8';
export const progressSize = (size) => {
    const sizeMap = {
        small: 2,
        medium: 4,
        large: 8,
    };
    return sizeMap[size] || size;
};
export const progressiveColor = (percent) => {
    if (percent < 33) {
        return '#EB2F2F';
    }
    if (percent > 66) {
        return '#05D161';
    }
    return '#D97B00';
};
export const progressCircleWidthSize = (size) => {
    const sizeMap = {
        small: 18,
        medium: 28,
        large: 43,
    };
    return sizeMap[size] || size;
};
export const progressCircleFontSize = (size) => {
    const sizeMap = {
        small: 12,
        medium: 14,
        large: 20,
    };
    return sizeMap[size] || size;
};
export const defaultTextRender = (percent) => {
    return `${Number(percent.toFixed(2))}%`;
};
